export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-truck-line',
      title: 'Fast Delivery and Collection',
      description: 'Quick response times with same-day delivery available. We work around your schedule.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Affordable Pricing with No Hidden Fees',
      description: 'Transparent pricing structure. What you see is what you pay - no surprises.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly Disposal Practices',
      description: 'We recycle up to 90% of waste collected, protecting our environment for future generations.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-16">
          Why S2K Waste Services?
        </h2>

        <div className="grid md:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start space-x-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg">
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
